import {RenameUserScheduleApiPayload} from "../../../../../react-query-hooks/schedule/types";
import {RenameUserScheduleFormValues} from "../components/rename-schedule-form/schema-validation";

export function renameUserScheduleDto(
  values: RenameUserScheduleFormValues
): RenameUserScheduleApiPayload {
  return {
    name: values.scheduleName,
    scheduleId: values.scheduleId,
  };
}
